import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Copy = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M38 8H20V4h18a4 4 0 0 1 4 4v22h-4V8ZM6 16a4 4 0 0 1 4-4h20c2.205 0 4 1.783 4 3.997v24.011A3.99 3.99 0 0 1 30.003 44H9.996A3.996 3.996 0 0 1 6 40V16Zm24 0H10v24h20V16Z"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
